import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from "../market";

const APTEKA_RU_FAQ = [
  {
    title: "Что такое «ПФ» или поведенческий сценарий на Аптека.ру*?",
    isH3: true,
    text: (
      <p>
        Так пользователи могут называть действия, которые совершаются на карточке товара (например, переход по ссылке, просмотр, добавление в корзину).
        <br />
        <br />
        Boostclick предоставляет возможность организовать такие действия в виде сценария, но не оценивает и не анализирует внутренние алгоритмы площадки.
      </p>
    ),
  },
  {
    title: "Влияют ли действия пользователей на рейтинг товара на Аптека.ру*?",
    isH3: true,
    text: (
      <p>
        Мы не можем утверждать, как именно работает система ранжирования Аптека.ру*.
        <br />
        <br />
        Сервис Boostclick не гарантирует влияния на позиции и не предоставляет аналитики по алгоритмам.
        <br />
        Также сервис не позваляет тестировщикам оставлять отзывы и оценивать товары.
        <br />
        Наша задача — предоставить инструмент, через который можно организовать действия реальных пользователей для получения обратной связи по карточке товаров.
      </p>
    ),
  },
  {
    title: 'Вы можете сделать «накрутку?»',
    isH3: true,
    text: (
      <p>
        Нет. 
        <br />
        <br />
        Boostclick не оказывает услуг «накрутки» и не гарантирует рост позиций или продаж.
        <br />
        Сценарии строятся только на основе ручного исполнения задач, без автоматизации и ботов. Упоминание слова «накрутка» используется исключительно для целей SEO и навигации пользователей.        <br />
      </p>
    ),
  },
  {
    title: 'Как создать проект на Boostclick для карточки на Аптека.ру*?',
    isH3: false,
    text: (
      <div>
        1. Зайдите в личный кабинет и создайте проект
        <br />
        2. Укажите ключевые фразы и ссылку на товар
        <br />
        3. Задайте типы действий (например, «перейти по фразе», «добавить в корзину»)
        <br />
        4. Установите количество исполнителей и бюджет
        <br />
        5. Пополните баланс и запустите проект
      </div>
    ),
  },
  {
    title: 'Какие гарантии?',
    isH3: false,
    text: (
      <p>
        Boostclick гарантирует, что все задания будут выполнены вручную, уникальными пользователями.
        <br />
        Вы можете проверять отчеты и отправлять задания на доработку, если необходимо. Все действия регулируются публичной офертой, размещенной на сайте. 
      </p>
    ),
  },
];

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
    сценарий начинается для нового исполнителя с поиска товара по сделанному
    скриншоту вашей ссылки.
  </p>
);

const ACTIONS = [
  {
    type: "ALWAYS.OPEN",
    icon: "open",
    iconHome: "home-open",
    title: "Открыть сайт / приложение Аптека.ру",
    initialShare: 1,
  },
  {
    type: "ALWAYS.SEARCH",
    icon: "search",
    iconHome: "home-search",
    title: "Найти товар по поисковому запросу",
    initialShare: 1,
  },
  {
    type: "ALWAYS.CLICK",
    icon: "click",
    iconHome: "home-click",
    title: "Зайти на карточку товара",
    initialShare: 1,
  },
  {
    type: "ALWAYS.DESCRIPTION",
    icon: "eye",
    iconHome: "home-eye",
    title: "Посмотреть фото и описание товара",
    initialShare: 1,
  },

  {
    type: "EXTRA.FEEDBACKS",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Почитать отзывы о товаре",
    initialShare: 0.7,
  },

  {
    type: "MAIN.FAVORITE",
    icon: "heart",
    iconHome: "home-heart",
    title: "Добавить товар в избранное",
    initialShare: 0.6,
    activityType: 'Избранное',
  },
  {
    type: "MAIN.BUSKET",
    icon: "busket",
    iconHome: "home-busket",
    title: "Добавить товар в корзину",
    initialShare: 0.4,
    activityType: 'Корзина',
  },

  {
    type: "EXTRA.ABOUT",
    icon: "click",
    iconHome: "home-click",
    title: "Открыть карточку производителя / продавца",
    initialShare: 0.3,
  }
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    titleComment: "Изучение товаров",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.NEW,
  },
  {
    iconHome: "home-heart",
    title: "В избранное",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "В корзину",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Открыть сайт или приложение",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти товар",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Карточка товара",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "Купить сейчас",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Почитать отзывы о товаре",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
  },
  {
    iconHome: "home-time",
    title: "Посмотреть фото и описание товара",
    path: "/povedencheskie-faktory-na-apteka-ru",
    target: '_self',
  },
];

const STEP_PHRASE_2 = "Укажите параметры карточки товара";

const APTEKA_RU_KEYWORDS = [
  'Apteka', 'apteka', 'Аптека', 'аптека'
];

class AptekaRuClass extends Market {
  id = "aptekaru";
  disabled = true;

  host = "apteka.ru";
  url = "https://apteka.ru/";

  title = "Аптека.ру";

  isMarketplace = true;
  isPharmacy = true;

  icon = "aptekaru";
  titlePlaces = "Аптека.ру";
  mainPageTitles = MAIN_PAGE_TITLES;
  statusForHomePage = MARKET_MODE_STATUS.NEW;

  chainsPerDayNormal = 200 / 30;

  chainPrice = 24;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = 0;

  chainsStep = 1;
  viewsStep = 10;

  keywords = APTEKA_RU_KEYWORDS;

  targetLinkComment = "Объем / дозировка";
  targetLinkCommentShort = "Укажите ссылку товара";

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: "/povedencheskie-faktory-na-apteka-ru",
      rating: 0.968,
      title: "ПФ",
      navigateTitle: "Поведение и тест карточек товаров",
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: "Накрутка ПФ ЛЮДИ на Аптека.ру — от 1.9 руб. | Boostclick",
        description: "Улучшайте ПФ ЛЮДИ на Аптека.ру — реальные пользователи, задание от 1.9 руб.",
        canonical: '/povedencheskie-faktory-na-apteka-ru',
      },
      intro: {
        title: "Продвижение товаров на Аптека.ру* через действия реальных пользователей",
        comment: "Сценарии взаимодействия и микрозадачи от уникальных исполнителей",
        points: [
          'Настраиваемые сценарии без ботов',
          'Только органический путь действий',
          'Уникальные пользователи для каждого задания',
          'Детализированные отчеты от исполнителей',
          'Поиск карточки по ключевым словам',
        ],
      },
      howItWorks: [
        /* "Настройте параметры активности в соответствии с конкуренцией",
        "Укажите ссылку на товар для скриншота",
        "Укажите город и ключевые фразы из карточки товара",
        "После оплаты мы передадим исполнителю скриншот и параметры для поиска",
        "Проверьте ответы и активность, примите работу или отправьте на доработку", */
      ],
      stepPhrase1: "Настройка сценария пользовательского взаимодействия на Аптека.ру*",
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: "Организация пользовательской активности на Аптека.ру*",
      titleFAQ: "Вопрос-ответ про раскрутку товаров на Аптека.ру",
      faq: APTEKA_RU_FAQ,
      actions: (() => {
        return [
          ...ACTIONS.filter(
            (action) =>
              action.type !== "MAIN.REVIEW" && !action.type.startsWith("VIEW.")
          ),
          ...ACTIONS.filter((action) => action.type === "MAIN.REVIEW"),
        ];
      })(),
      notice: [
        "* Сервис сгенерирует уникальные цепочки действий с учетом поисковых запросов.",
        'Платформа формирует индивидуальные задания, включающие переход по ключевым фразам, просмотр карточки, взаимодействие с элементами (добавление в избранное, корзину и др.).',
        'Каждому исполнителю назначается уникальный сценарий.',
        'Сложность и длительность сценариев зависят от параметров проекта.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action;
    return map;
  }, {});
}

const AptekaRu = new AptekaRuClass();
export default AptekaRu;
